 import { Injectable } from '@angular/core';
import {State, Action, StateContext, Selector} from '@ngxs/store';
import { updateMnemonic } from './mnemonic.action';
 
export class MnemonicModel{
    
  mnemonic:string;
 
 }
 @State<MnemonicModel>({
     name: 'Mnemomicstate',
     defaults: {
       
          mnemonic:'',
        
      }
 })
 @Injectable()
 export class MnemonicState {
 
     constructor( ) {
     }
 
     @Selector()
     static getMnemonic(state: MnemonicModel) {
         return state;
     }
    

     @Action(updateMnemonic)
     updateMnemonic({getState, patchState}: StateContext<MnemonicModel>, {payload}: updateMnemonic) {
         const state = getState();
         patchState({
              mnemonic:payload
            });
     }
     
    } 